module.exports = __webpack_public_path__ + "img/autouparrow.cdb052a3.svg";